<template>
  <div class="strategys-area-content" v-loading="loading">
    <div class="con-table">
      <div class="control-group">
        <div class="group-tip">设置了区域策略后，绑定的路灯会根据经纬度算出该地日出日落的时间，根据太阳光线强弱，路灯自动调光和开关</div>
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>新建策略</el-button
          >
        </div>
      </div>
      <div class="h20"></div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="title" label="策略名称" width="220"></el-table-column>
        <el-table-column prop="lnglat" label="经纬度" width="220"></el-table-column>
        <el-table-column label="日落时间">
          <template slot-scope="scope">
            {{scope.row.sunset_time}}<br/>
            <template v-if="scope.row.sunset">
              <!-- 提前 -->
              {{scope.row.sunset_offset?'设置提前'+scope.row.sunset_offset+'分钟':'未设置'}}
            </template>
            <template v-else>
              <!-- 延迟 -->
              {{scope.row.sunset_offset?'设置延迟'+scope.row.sunset_offset+'分钟':'未设置'}}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="open_light_time" label="开灯时间" width="150"></el-table-column>
        <el-table-column label="日出时间">
          <template slot-scope="scope">
            {{scope.row.sunrise_time}}<br/>
            <template v-if="scope.row.sunrise">
              <!-- 提前 -->
              {{scope.row.sunrise_offset?'设置提前'+scope.row.sunrise_offset+'分钟':'未设置'}}
            </template>
            <template v-else>
              <!-- 延迟 -->
              {{scope.row.sunrise_offset?'设置延迟'+scope.row.sunrise_offset+'分钟':'未设置'}}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="close_light_time" label="关灯时间" width="150"></el-table-column>
        <el-table-column label="亮度" width="150">
          <template slot-scope="scope">
            {{scope.row.sunset_light}} %
          </template>
        </el-table-column>
        <el-table-column prop="edit" label="操作" width="120">
          <template slot-scope="scope">
            <div class="table-last">
              <span @click="openEditWin(scope.row)" class="blue pointer mar-r10">编辑</span>
              <span @click="delItem(scope.row.id)" class="blue pointer">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
    

    <!--新增修改路灯策略 开始-->
    <el-dialog
      v-if="dialogVisible"
      class="dialog860"
      :title="editType === 'create' ? '新增日出日落策略' : '编辑日出日落策略'"
      :visible.sync="dialogVisible"
      
    >
      <el-form
        :model="editOne"
        ref="editOneRef"
        label-position="left"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-row :gutter="20" class="item-list">
            <el-col :span="12">
              <el-form-item label="策略名称" prop="title">
                <el-input v-model="editOne.title" placeholder="请输入策略名称"></el-input>
              </el-form-item>
              <el-form-item label="经度" prop="longitude">
                <el-input v-model="editOne.longitude" placeholder="请输入经度"></el-input>
              </el-form-item>
              <el-form-item label="纬度" prop="latitude">
                <el-input v-model="editOne.latitude" placeholder="请输入纬度"></el-input>
              </el-form-item>
              <div class="form-time-box">
                <span class="label">预计开灯时间</span>
                <el-time-picker
                  :clearable="false"
                  class="area-input"
                  format='HH:mm'
                  @change="changeTime(1)"
                  v-model="editOne.open_light_time"
                  :picker-options="{
                    selectableRange: editOne.sunset_rang,
                  }"
                  placeholder="请输入开灯时间">
                </el-time-picker>
                <div v-if="editOne.sunset_delay>0"  class="time">延迟{{parseInt(editOne.sunset_delay)}}分钟</div>
                <div v-if="editOne.sunset_delay<0"  class="time">提前{{parseInt(editOne.sunset_delay)*-1}}分钟</div>
              </div>
              <div class="form-time-box">
                <span class="label">预计关灯时间</span>
                <el-time-picker
                  :clearable="false"
                  class="area-input"
                  format='HH:mm'
                  @change="changeTime(0)"
                  v-model="editOne.close_light_time"
                  :picker-options="{
                    selectableRange: editOne.sunrise_rang,
                  }"
                  placeholder="请输入关灯时间">
                </el-time-picker>
                <div v-if="editOne.sunrise_delay>0" class="time" >延迟{{parseInt(editOne.sunrise_delay)}}分钟</div>
                <div v-if="editOne.sunrise_delay<0" class="time">提前{{parseInt(editOne.sunrise_delay)*-1}}分钟</div>
              </div>
              <div class="form-time-box">
                <span class="label">路灯亮度调节</span>
                <el-slider
                  class="yellow-slider"
                  v-model="editOne.sunset_light"
                  :min="0"
                  :max="100"
                ></el-slider>
                <div class="number">{{editOne.sunset_light}}%</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="map-box">
                <area-map :nowlng="editOne.longitude" :nowlat="editOne.latitude" @mapDing="getCoordinate" />
              </div>
            </el-col>
          </el-row>

          <div class="lamp-transfer strategy-area-transfer">
            <el-transfer
              filterable
              filter-placeholder="请输入路灯别名或序列号"
              :data="allDevices"
              :titles="['可选路灯', '已选路灯']"
              :button-texts="['删除到可选', '添加到已选']"
              v-model="allocated"
            >
            </el-transfer>
          </div>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="box-footer">
          <el-button class="cancel-btn" size="medium" @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" size="medium" @click="verifyItem()">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增修改路灯策略 结束 -->
  </div>
</template>
<script>
import time from "@/utils/time";
import moment from "moment";
import strategyApi from "@/api/light/strategy"
import areaMap from '@/components/areaMap'
export default {
  name: "strategyArea",
  components: {
    areaMap
  },
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: {
        type: 0,
        strategy_type: 3,
        page: 1,
        pageSize: 10
      },
      cnt_all: 0,
      dialogVisible: false,
      editOneRule: {
        title: [{ required: true, message: "请输入策略名称", trigger: "blur" }],
        longitude: [{ required: true, message: "请输入经度", trigger: "blur" }],
        latitude: [{ required: true, message: "请输入纬度", trigger: "blur" }],
      },
      editType: -1,
      editOne: {
        id: '',
        title: '',
        strategy_type: 3,
        longitude: '',
        latitude: '',
        sunset_time: '',
        sunrise_time: '',
        open_light_time: '',
        close_light_time: '',
        sunset_delay: 0,
        sunrise_delay: 0,
        sunset_light: 0, //日落开灯亮度
        sunrise_light: 0, // 日出关灯亮度0
        sunset_rang: '00:00-24:00',
        sunrise_rang: '00:00-24:00'
      },
      allDevices: [],
      allocated: []
    };
  },
  methods: {
    ...time,
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex
      this.loading = true
      this.tableData = []
      strategyApi.strategyList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      this.allDevices = []
      this.allocated = []
      if (index === "create") {
        if(this.cnt_all){
          return this.$message.error('区域策略只能存在一条！')
        }
        this.editOne = {
          id: '',
          title: '',
          strategy_type: 3,
          longitude: '',
          latitude: '',
          sunrise_light: 0, // 日出亮度0
          sunset_time: 0,
          sunrise_time: 0,
          open_light_time: '',
          close_light_time: '',
          sunset_delay: 0,
          sunrise_delay: 0,
          sunset_light: 0, //日落亮度
          sunset_rang: '00:00-24:00',
          sunrise_rang: '00:00-24:00'
        };
        this.editType = "create";
      } else {
        console.log('index', index)
        this.editOne = {
          id: index.id,
          title: index.title,
          strategy_type: 3,
          longitude: index.longitude,
          latitude: index.latitude,
          sunset_time: index.sunset_time, // 日落
          sunrise_time: index.sunrise_time, //日出
          open_light_time: this.numberToTime(this.HmToNumber(index.open_light_time)), // picker插件需要日期格式
          close_light_time: this.numberToTime(this.HmToNumber(index.close_light_time)), // picker插件需要日期格式
          sunset_delay: (this.HmToNumber(index.open_light_time) - this.HmToNumber(index.sunset_time))/60, // 日落开灯延迟或提前
          sunrise_delay: (this.HmToNumber(index.close_light_time) - this.HmToNumber(index.sunrise_time))/60, //日出开灯延迟或提前
          sunset_light: index.sunset_light, //日落开灯亮度
          sunrise_light: index.sunrise_light, // 日出 （关灯）亮度0、（保留功能，可能有的不会关为0）
          sunset_rang: '00:00-24:00', //日落开灯选择的范围（初始） 下面this.setTimeRang()根据日落（sunset_time）设定范围
          sunrise_rang: '00:00-24:00' //日出关灯选择的范围（初始） 下面this.setTimeRang()根据日出（sunrise_time）设定范围
        };
        console.log('this.editOne', this.editOne)

        this.setTimeRang()
        this.editType = "update";
      }
      this.dialogVisible = true;
      this.loading = false;
      this.getLampList('');
    },
    verifyItem(){
      const { title, longitude, latitude, open_light_time, close_light_time, sunset_light } = this.editOne;
      if(!title){
        return this.$message.error('请输入策略名称！')
      }
      if(!longitude||!latitude){
        return this.$message.error('请输入经纬度！')
      }

      if(!open_light_time){
        return this.$message.error('开灯时间不能为空！')
      }
      if(!close_light_time){
        return this.$message.error('关灯时间不能为空！')
      }

      if(!sunset_light){
        return this.$message.error('日落开灯亮度应大于0！')
      }

      let params = {
        title: title,
        strategy_type: 3,
        longitude: longitude,
        latitude: latitude,
        open_light_time: moment(open_light_time).format("HH:mm"),
        close_light_time: moment(close_light_time).format("HH:mm"),
        sunset_light: sunset_light,
        sunrise_light: 0,
        ids: ''
      }
      
      if(this.allocated.length){
        params.ids=this.allocated.toString();
      }
      if(this.editType == "create"){
        this.createItem(params)
      }else{
        this.updateItem(params)
      }
    },
    createItem(params) {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          strategyApi.strategyAdd(params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("添加成功");
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          })
        } else {
          return false
        }
      })
    },
    updateItem(params) {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          strategyApi.strategyEdit(this.editOne.id,params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("修改成功")
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          return false
        }
      })
    },  
    getLampList(id) {
      let that = this
      strategyApi.getSunStrategy({
        id: id,
        page: 1,
        pageSize: 1000
      }).then((res) => {
        if (res.data.code === 1000) {
          let arrData = []
          let resData = res.data.data
          if(resData.length){
            for (const lamp of resData) {
              arrData.push({
                key: lamp.id+'_'+lamp.type,
                label: lamp.name+'-'+lamp.number
              })
            }
          }
          that.allocated = []
          if(id){
            if(arrData.length){
              for (const item of arrData) {
                that.allocated.push(item.key)
              }
              that.allDevices = [...that.allDevices, ...arrData]
              that.allDevices = Array.from(new Set(that.allDevices))
            }
          }else{
            that.allDevices = arrData
            if(that.editOne.id){
              that.getLampList(that.editOne.id)
            }
          }
        }
      })
    },

    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        strategyApi.strategyDel(id).then((res) => {
          if (res.data.code === 1000) {
            this.$popupMessage({
              type: 'success',
              title: "删除成功"
              // msg: '如果未刷新，请耐心等待5秒，点击刷新列表查看结果'
            })
            this.getTableData(this.pageInfo.page);
          } else {
            this.$popupMessage({
              type: 'error',
              title: "提示",
              msg: res.data.message,
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },
    getCoordinate(map) {
      let that = this
      that.editOne.longitude = map.lng
      that.editOne.latitude = map.lat
      strategyApi.getDateSunInfo({
        longitude: map.lng,
        latitude: map.lat,
      }).then((res) => {
        console.log('getCoordinate', res)
        if (res.data.code === 1000) {
          if(res.data.data.sunset_time!=that.editOne.sunset_time){
            that.editOne.sunset_delay = 0
            that.editOne.sunrise_delay = 0

            that.editOne.sunset_time = res.data.data.sunset_time
            that.editOne.open_light_time = that.numberToTime(that.HmToNumber(res.data.data.sunset_time))
            that.editOne.sunrise_time = res.data.data.sunrise_time
            that.editOne.close_light_time = that.numberToTime(that.HmToNumber(res.data.data.sunrise_time))
            that.setTimeRang()
          }
        }
      })
    },
    setTimeRang(){ // 设置 时间范围
      let maxTimeSunset_time =  moment(this.numberToTime(this.HmToNumber(this.editOne.sunset_time)+3600)).format("HH:mm");
      let minTimeSunset_time =  moment(this.numberToTime(this.HmToNumber(this.editOne.sunset_time)-3600)).format("HH:mm")
      let maxTimeSunrise_time =  moment(this.numberToTime(this.HmToNumber(this.editOne.sunrise_time)+3600)).format("HH:mm")
      let minTimeSunrise_time =  moment(this.numberToTime(this.HmToNumber(this.editOne.sunrise_time)-3600)).format("HH:mm")
      this.editOne.sunset_rang = minTimeSunset_time+':00-'+maxTimeSunset_time+':00'
      this.editOne.sunrise_rang = minTimeSunrise_time+':00-'+maxTimeSunrise_time+':00'
    },
    changeTime(type){ //1 预计开灯时间， 0预计关灯时间
      if(type==1){
        let  sunset_times = this.editOne.sunset_time // 日落时间
        let  open_light_times = this.editOne.open_light_time // 日落开灯时间
        this.editOne.sunset_delay = (this.HmToNumber(moment(open_light_times).format("HH:mm")) - this.HmToNumber(sunset_times))/60 //分钟
      }else{
        let  sunrise_times = this.editOne.sunrise_time // 日出时间
        let  close_light_times = this.editOne.close_light_time // 日出关灯时间
        this.editOne.sunrise_delay = (this.HmToNumber(moment(close_light_times).format("HH:mm")) - this.HmToNumber(sunrise_times))/60 //分钟
      }
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page)
  },
};
</script>

<style lang='less'>
.strategys-area-content{
  padding:0 0 20px;
  .con-table{
    padding-bottom: 10px;
  }
  .form-time-box{
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    span.label{
      margin-right: 20px;
      color: #1d2129;
    }
    .area-input,.yellow-slider{
      flex: 1;
      min-width:100px;
    }
    .area-input{
      flex: 1;
      .el-input__prefix{
        left: auto !important;
        right:10px !important;
        font-size: 16px;
        top:2px;
      }
      .el-input__inner{
        padding-left: 20px !important;
      }
    }
    .time,.number{
      color:#e7542f;
      font-size: 13px;
      margin-left: 20px;
    }
    .number{
      font-size: 14px;
      color: #1d2129;
    }
  }
  .map-box{
    padding: 0 !important;
  }
  .strategy-area-transfer{
    margin-top:20px;
    padding-top: 30px;
    border-top:1px solid #dcdee2;
    .el-transfer__buttons{
      .el-transfer__button{
        left:100px !important;
        &:first-child{
          left: auto !important;
          right:100px !important;
        }
      }
    }
  }
  .form-info{
    .el-form-item__label{
      width:85px;
    }
  }
}
</style>
